import React from "react";
import { ViewMorePaymentMethod } from "../../pages";

const ViewMorePaymentMethodContainer = ({ selectedItem, closeModal }) => {
  return (
    <ViewMorePaymentMethod
      selectedItem={selectedItem}
      closeModal={closeModal}
    />
  );
};

export default ViewMorePaymentMethodContainer;
